import axios from 'api/axiosConfig'

const BASE = '/gift-cards'

export const giftCardsAPI = {
 list: (params?: Record<string, any>) => axios.get(BASE, { params }),
 show: (id: number) => axios.get(`${BASE}/${id}`),
 create: (data: Record<string, any>) => axios.post(BASE, data),
 checkCode: (code: string) => axios.post(`${BASE}/check`, { code }),
 redeem: (id: number, data: { amount: number; sale_id?: number; customer_id?: number }) =>
 axios.post(`${BASE}/${id}/redeem`, data),
 cancel: (id: number) => axios.post(`${BASE}/${id}/cancel`),
 statistics: () => axios.get(`${BASE}/statistics`),
}
